import { Link } from "react-router-dom";

const ProductListOne = ({ products = [], isLoading, isError }) => {
	if (isLoading) {
		return (
			<div className="min-vh-100 product mt-24 text-center py-5">
				<h5>Loading products...</h5>
			</div>
		);
	}

	if (isError) {
		return (
			<div className="min-vh-100 product mt-24 text-center py-5 text-danger">
				<h5>Failed to load products. Please try again later.</h5>
			</div>
		);
	}

	if (!products.length) {
		return (
			<div className="min-vh-100 product mt-24 text-center py-5">
				<h5>No products found.</h5>
			</div>
		);
	}

	return (
		<div id="products" className="product mt-24 min-vh-100">
			<div className="container container-lg">
				<div className="row gy-4 g-12">
					{products.map((item) => {
						const imageUrl =
							item.images?.[0]?.src ||
							"https://via.placeholder.com/300?text=No+Image";

						const regularPrice =
							!item.isVoucher && item.regular_price
								? parseFloat(item.regular_price).toFixed(2)
								: null;

						const price = item.price
							? parseFloat(item.price).toFixed(2)
							: null;

						const showDiscount =
							regularPrice && regularPrice !== price;

						const productUrl = item.isVoucher
							? `https://vouchers.perk.gift/shop/store2?product=${item.id}`
							: item.permalink;

						return (
							<div
								key={item.id}
								className="col-xxl-2 col-lg-3 col-sm-4 col-6"
							>
								<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 h-100 d-flex flex-column">
									{item.isVoucher && (
										<span
											style={{
												backgroundColor:
													item.deliveryType ===
													"DELAYED"
														? "orange"
														: "green",
											}}
											className="product-card__badge px-8 py-4 text-sm text-white"
										>
											{item.deliveryType}
										</span>
									)}
									<Link
										// to={
										// 	item.isVoucher
										// 		? `/voucher-details/${item.id}`
										// 		: `/product-details/${item.id}`
										// }
										to={productUrl}
										className="product-card__thumb flex-center"
									>
										<img
											src={imageUrl}
											alt={item.name || "Product image"}
											style={{
												maxHeight: "200px",
												objectFit: "contain",
											}}
										/>
									</Link>

									<div className="product-card__content mt-12 d-flex flex-column flex-grow-1 w-100">
										{/* Price Section */}
										<div className="mb-12">
											{showDiscount && (
												<span className="text-gray-400 text-md fw-semibold text-decoration-line-through me-2">
													${regularPrice}
												</span>
											)}
											{price && (
												<span className="text-heading text-md fw-semibold">
													${price}{" "}
													{/* <span className="text-gray-500 fw-normal">
														/Qty
													</span> */}
												</span>
											)}
										</div>

										<h6 className="title text-lg fw-semibold mt-0 mb-8">
											<Link
												// to={
												// 	item.isVoucher
												// 		? `/voucher-details/${item.id}`
												// 		: `/product-details/${item.id}`
												// }
												to={productUrl}
												className="link text-line-2"
											>
												{item.name}
											</Link>
										</h6>

										{/* Vendor / Additional info */}
										{/* {!item.isVoucher && (
											<div className="flex-align gap-4 mb-4">
												<span className="text-gray-500 text-xs">
													{item.vendor ||
														"WooCommerce Store"}
												</span>
											</div>
										)} */}

										{/* Voucher badge */}
										<div className="voucher-badge px-2 py-1 bg-green-100 text-green-800 rounded text-xs inline-block">
											{item.isVoucher
												? "Gift Voucher"
												: "Seller Product"}
										</div>

										<div className="mt-auto w-100">
											<Link
												to={productUrl}
												className="product-card__cart btn opacity-50 bg-main-50 text-white hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center w-100"
											>
												Add To Cart{" "}
												<i className="ph ph-shopping-cart" />
											</Link>
										</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default ProductListOne;

// import React from 'react'
// import { Link } from 'react-router-dom'

// const ProductListOne = () => {
// 	return (
// 		<div className="product mt-24">
// 			<div className="container container-lg">
// 				<div className="row gy-4 g-12">
// 					<div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
// 						<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
// 							<Link
// 								to="/cart"
// 								className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
// 							>
// 								Add <i className="ph ph-shopping-cart" />
// 							</Link>
// 							<Link
// 								to="/product-details"
// 								className="product-card__thumb flex-center"
// 							>
// 								<img src="assets/images/thumbs/product-img1.png" alt="" />
// 							</Link>
// 							<div className="product-card__content mt-12">
// 								<div className="product-card__price mb-16">
// 									<span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
// 										$28.99
// 									</span>
// 									<span className="text-heading text-md fw-semibold ">
// 										$14.99 <span className="text-gray-500 fw-normal">/Qty</span>{" "}
// 									</span>
// 								</div>
// 								<div className="flex-align gap-6">
// 									<span className="text-xs fw-bold text-gray-600">4.8</span>
// 									<span className="text-15 fw-bold text-warning-600 d-flex">
// 										<i className="ph-fill ph-star" />
// 									</span>
// 									<span className="text-xs fw-bold text-gray-600">(17k)</span>
// 								</div>
// 								<h6 className="title text-lg fw-semibold mt-12 mb-8">
// 									<Link to="/product-details" className="link text-line-2">
// 										Taylor Farms Broccoli Florets Vegetables
// 									</Link>
// 								</h6>
// 								<div className="flex-align gap-4">
// 									<span className="text-main-600 text-md d-flex">
// 										<i className="ph-fill ph-storefront" />
// 									</span>
// 									<span className="text-gray-500 text-xs">
// 										By Lucky Supermarket
// 									</span>
// 								</div>
// 								<div className="mt-12">
// 									<div
// 										className="progress w-100  bg-color-three rounded-pill h-4"
// 										role="progressbar"
// 										aria-label="Basic example"
// 										aria-valuenow={35}
// 										aria-valuemin={0}
// 										aria-valuemax={100}
// 									>
// 										<div
// 											className="progress-bar bg-main-600 rounded-pill"
// 											style={{ width: "35%" }}
// 										/>
// 									</div>
// 									<span className="text-gray-900 text-xs fw-medium mt-8">
// 										Sold: 18/35
// 									</span>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 					<div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
// 						<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
// 							<Link
// 								to="/cart"
// 								className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
// 							>
// 								Add <i className="ph ph-shopping-cart" />
// 							</Link>
// 							<Link
// 								to="/product-details"
// 								className="product-card__thumb flex-center"
// 							>
// 								<img src="assets/images/thumbs/product-img2.png" alt="" />
// 							</Link>
// 							<div className="product-card__content mt-12">
// 								<div className="product-card__price mb-16">
// 									<span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
// 										$28.99
// 									</span>
// 									<span className="text-heading text-md fw-semibold ">
// 										$14.99 <span className="text-gray-500 fw-normal">/Qty</span>{" "}
// 									</span>
// 								</div>
// 								<div className="flex-align gap-6">
// 									<span className="text-xs fw-bold text-gray-600">4.8</span>
// 									<span className="text-15 fw-bold text-warning-600 d-flex">
// 										<i className="ph-fill ph-star" />
// 									</span>
// 									<span className="text-xs fw-bold text-gray-600">(17k)</span>
// 								</div>
// 								<h6 className="title text-lg fw-semibold mt-12 mb-8">
// 									<Link to="/product-details" className="link text-line-2">
// 										Taylor Farms Broccoli Florets Vegetables
// 									</Link>
// 								</h6>
// 								<div className="flex-align gap-4">
// 									<span className="text-main-600 text-md d-flex">
// 										<i className="ph-fill ph-storefront" />
// 									</span>
// 									<span className="text-gray-500 text-xs">
// 										By Lucky Supermarket
// 									</span>
// 								</div>
// 								<div className="mt-12">
// 									<div
// 										className="progress w-100  bg-color-three rounded-pill h-4"
// 										role="progressbar"
// 										aria-label="Basic example"
// 										aria-valuenow={35}
// 										aria-valuemin={0}
// 										aria-valuemax={100}
// 									>
// 										<div
// 											className="progress-bar bg-main-600 rounded-pill"
// 											style={{ width: "35%" }}
// 										/>
// 									</div>
// 									<span className="text-gray-900 text-xs fw-medium mt-8">
// 										Sold: 18/35
// 									</span>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 					<div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
// 						<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
// 							<Link
// 								to="/cart"
// 								className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
// 							>
// 								Add <i className="ph ph-shopping-cart" />
// 							</Link>
// 							<Link
// 								to="/product-details"
// 								className="product-card__thumb flex-center"
// 							>
// 								<img src="assets/images/thumbs/product-img3.png" alt="" />
// 							</Link>
// 							<div className="product-card__content mt-12">
// 								<div className="product-card__price mb-16">
// 									<span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
// 										$28.99
// 									</span>
// 									<span className="text-heading text-md fw-semibold ">
// 										$14.99 <span className="text-gray-500 fw-normal">/Qty</span>{" "}
// 									</span>
// 								</div>
// 								<div className="flex-align gap-6">
// 									<span className="text-xs fw-bold text-gray-600">4.8</span>
// 									<span className="text-15 fw-bold text-warning-600 d-flex">
// 										<i className="ph-fill ph-star" />
// 									</span>
// 									<span className="text-xs fw-bold text-gray-600">(17k)</span>
// 								</div>
// 								<h6 className="title text-lg fw-semibold mt-12 mb-8">
// 									<Link to="/product-details" className="link text-line-2">
// 										Taylor Farms Broccoli Florets Vegetables
// 									</Link>
// 								</h6>
// 								<div className="flex-align gap-4">
// 									<span className="text-main-600 text-md d-flex">
// 										<i className="ph-fill ph-storefront" />
// 									</span>
// 									<span className="text-gray-500 text-xs">
// 										By Lucky Supermarket
// 									</span>
// 								</div>
// 								<div className="mt-12">
// 									<div
// 										className="progress w-100  bg-color-three rounded-pill h-4"
// 										role="progressbar"
// 										aria-label="Basic example"
// 										aria-valuenow={35}
// 										aria-valuemin={0}
// 										aria-valuemax={100}
// 									>
// 										<div
// 											className="progress-bar bg-main-600 rounded-pill"
// 											style={{ width: "35%" }}
// 										/>
// 									</div>
// 									<span className="text-gray-900 text-xs fw-medium mt-8">
// 										Sold: 18/35
// 									</span>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 					<div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
// 						<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
// 							<Link
// 								to="/cart"
// 								className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
// 							>
// 								Add <i className="ph ph-shopping-cart" />
// 							</Link>
// 							<Link
// 								to="/product-details"
// 								className="product-card__thumb flex-center"
// 							>
// 								<img src="assets/images/thumbs/product-img1.png" alt="" />
// 							</Link>
// 							<div className="product-card__content mt-12">
// 								<div className="product-card__price mb-16">
// 									<span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
// 										$28.99
// 									</span>
// 									<span className="text-heading text-md fw-semibold ">
// 										$14.99 <span className="text-gray-500 fw-normal">/Qty</span>{" "}
// 									</span>
// 								</div>
// 								<div className="flex-align gap-6">
// 									<span className="text-xs fw-bold text-gray-600">4.8</span>
// 									<span className="text-15 fw-bold text-warning-600 d-flex">
// 										<i className="ph-fill ph-star" />
// 									</span>
// 									<span className="text-xs fw-bold text-gray-600">(17k)</span>
// 								</div>
// 								<h6 className="title text-lg fw-semibold mt-12 mb-8">
// 									<Link to="/product-details" className="link text-line-2">
// 										Taylor Farms Broccoli Florets Vegetables
// 									</Link>
// 								</h6>
// 								<div className="flex-align gap-4">
// 									<span className="text-main-600 text-md d-flex">
// 										<i className="ph-fill ph-storefront" />
// 									</span>
// 									<span className="text-gray-500 text-xs">
// 										By Lucky Supermarket
// 									</span>
// 								</div>
// 								<div className="mt-12">
// 									<div
// 										className="progress w-100  bg-color-three rounded-pill h-4"
// 										role="progressbar"
// 										aria-label="Basic example"
// 										aria-valuenow={35}
// 										aria-valuemin={0}
// 										aria-valuemax={100}
// 									>
// 										<div
// 											className="progress-bar bg-main-600 rounded-pill"
// 											style={{ width: "35%" }}
// 										/>
// 									</div>
// 									<span className="text-gray-900 text-xs fw-medium mt-8">
// 										Sold: 18/35
// 									</span>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 					<div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
// 						<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
// 							<Link
// 								to="/cart"
// 								className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
// 							>
// 								Add <i className="ph ph-shopping-cart" />
// 							</Link>
// 							<Link
// 								to="/product-details"
// 								className="product-card__thumb flex-center"
// 							>
// 								<img src="assets/images/thumbs/product-img5.png" alt="" />
// 							</Link>
// 							<div className="product-card__content mt-12">
// 								<div className="product-card__price mb-16">
// 									<span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
// 										$28.99
// 									</span>
// 									<span className="text-heading text-md fw-semibold ">
// 										$14.99 <span className="text-gray-500 fw-normal">/Qty</span>{" "}
// 									</span>
// 								</div>
// 								<div className="flex-align gap-6">
// 									<span className="text-xs fw-bold text-gray-600">4.8</span>
// 									<span className="text-15 fw-bold text-warning-600 d-flex">
// 										<i className="ph-fill ph-star" />
// 									</span>
// 									<span className="text-xs fw-bold text-gray-600">(17k)</span>
// 								</div>
// 								<h6 className="title text-lg fw-semibold mt-12 mb-8">
// 									<Link to="/product-details" className="link text-line-2">
// 										Taylor Farms Broccoli Florets Vegetables
// 									</Link>
// 								</h6>
// 								<div className="flex-align gap-4">
// 									<span className="text-main-600 text-md d-flex">
// 										<i className="ph-fill ph-storefront" />
// 									</span>
// 									<span className="text-gray-500 text-xs">
// 										By Lucky Supermarket
// 									</span>
// 								</div>
// 								<div className="mt-12">
// 									<div
// 										className="progress w-100  bg-color-three rounded-pill h-4"
// 										role="progressbar"
// 										aria-label="Basic example"
// 										aria-valuenow={35}
// 										aria-valuemin={0}
// 										aria-valuemax={100}
// 									>
// 										<div
// 											className="progress-bar bg-main-600 rounded-pill"
// 											style={{ width: "35%" }}
// 										/>
// 									</div>
// 									<span className="text-gray-900 text-xs fw-medium mt-8">
// 										Sold: 18/35
// 									</span>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 					<div className="col-xxl-2 col-lg-3 col-sm-4 col-6">
// 						<div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
// 							<Link
// 								to="/cart"
// 								className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 position-absolute inset-block-start-0 inset-inline-end-0 me-16 mt-16"
// 							>
// 								Add <i className="ph ph-shopping-cart" />
// 							</Link>
// 							<Link
// 								to="/product-details"
// 								className="product-card__thumb flex-center"
// 							>
// 								<img src="assets/images/thumbs/product-img6.png" alt="" />
// 							</Link>
// 							<div className="product-card__content mt-12">
// 								<div className="product-card__price mb-16">
// 									<span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
// 										$28.99
// 									</span>
// 									<span className="text-heading text-md fw-semibold ">
// 										$14.99 <span className="text-gray-500 fw-normal">/Qty</span>{" "}
// 									</span>
// 								</div>
// 								<div className="flex-align gap-6">
// 									<span className="text-xs fw-bold text-gray-600">4.8</span>
// 									<span className="text-15 fw-bold text-warning-600 d-flex">
// 										<i className="ph-fill ph-star" />
// 									</span>
// 									<span className="text-xs fw-bold text-gray-600">(17k)</span>
// 								</div>
// 								<h6 className="title text-lg fw-semibold mt-12 mb-8">
// 									<Link to="/product-details" className="link text-line-2">
// 										Taylor Farms Broccoli Florets Vegetables
// 									</Link>
// 								</h6>
// 								<div className="flex-align gap-4">
// 									<span className="text-main-600 text-md d-flex">
// 										<i className="ph-fill ph-storefront" />
// 									</span>
// 									<span className="text-gray-500 text-xs">
// 										By Lucky Supermarket
// 									</span>
// 								</div>
// 								<div className="mt-12">
// 									<div
// 										className="progress w-100  bg-color-three rounded-pill h-4"
// 										role="progressbar"
// 										aria-label="Basic example"
// 										aria-valuenow={35}
// 										aria-valuemin={0}
// 										aria-valuemax={100}
// 									>
// 										<div
// 											className="progress-bar bg-main-600 rounded-pill"
// 											style={{ width: "35%" }}
// 										/>
// 									</div>
// 									<span className="text-gray-900 text-xs fw-medium mt-8">
// 										Sold: 18/35
// 									</span>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>

// 	)
// }

// export default ProductListOne
